const dataPeriodo = {
  inicio: new Date(new Date().getFullYear(), 0, 1),
  termino: new Date(new Date().getFullYear(), 11, 31),
};

export default dataPeriodo;
